import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SeparatedWaste {
  glass: boolean;
  plastic: boolean;
  paperAndCardboard: boolean;
  organic: boolean;
}

export interface HouseholdHabitsState {
  waterUseMonthly: number;
  recycle: boolean;
  separatedWaste: SeparatedWaste;
}

const initialState: HouseholdHabitsState = {
  waterUseMonthly: 25,
  recycle: false,
  separatedWaste: {
    plastic: false,
    glass: false,
    paperAndCardboard: false,
    organic: false,
  },
};

interface SetSeparatedWastePayload {
  waste: keyof SeparatedWaste;
  value: boolean;
}

export const householdHabitsSlice = createSlice({
  name: "householdHabits",
  initialState,
  reducers: {
    setWaterUseMonthly(state, action: PayloadAction<number>) {
      state.waterUseMonthly = action.payload;
    },
    setRecycle(state, action: PayloadAction<boolean>) {
      state.recycle = action.payload;
    },
    setSeparatedWaste(state, action: PayloadAction<SetSeparatedWastePayload>) {
      const { waste, value } = action.payload;
      state.separatedWaste[waste] = value;
    },
    setHouseholdHabitsState(
      state,
      action: PayloadAction<HouseholdHabitsState>
    ) {
      state = action.payload;
    },
  },
});

export const {
  setWaterUseMonthly,
  setRecycle,
  setSeparatedWaste,
  setHouseholdHabitsState,
} = householdHabitsSlice.actions;

export default householdHabitsSlice.reducer;
